<template>
  <custom-dialog
    width="1200px"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
  >
    <div class="dialog-body">
      <div class="table-bd">
        <custom-table
          height="500"
          tableCode="dms_sim_country_code"
          :data="dataList"
          @sort="sortChange"
          @filter="filterChange"
          :slots="['action', 'newLastCountryCode']"
        >
          <template v-slot:newLastCountryCode="scope">
            <custom-select
              v-model="scope.row.newLastCountryCode"
              code="dms_sim_country_code"
              :props="{label: 'value', value: 'value'}"
            ></custom-select>
          </template>
          <template v-slot:action="scope">
            <el-button
              @click="onDelRow(scope.row)"
              type="text"
              size="mini"
            >{{ $t('Common.com_delete') }}</el-button>
          </template>
        </custom-table>
      </div>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button
        :disabled="!validate"
        type="primary"
        @click="onConfirm"
      >{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        lastCountryCode: '',
      },
      dataList: [],
    };
  },
  computed: {
    rules() {
      return {
        lastCountryCode: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
      };
    },
    validate() {
      const hasEmpty = this.dataList.some((item) => !item.newLastCountryCode);
      const validate = !hasEmpty;
      return validate;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const rows = Array.isArray(this.model.data) ? [...this.model.data] : [this.model.data];
      this.dataList = rows.map((item) => ({
        ...item,
        newLastCountryCode: '',
      }));
    },
    onDelRow(row) {
      const tips = this.$t('dms_change_isp_country_dialog.qdyscsxSIMkm');
      this.$showConfirm(tips).then(() => {
        this.dataList = this.dataList.filter((item) => item.simId !== row.simId);
      });
    },
    getSubmitReqData() {
      const rows = this.dataList;
      const ret = rows.map((item) => {
        const obj = {
          imsi: item.imsi,
          lastCountryCode: item.newLastCountryCode,
        };

        return obj;
      });

      return ret;
    },

    onConfirm() {
      const reqData = this.getSubmitReqData();
      this.$postJSON(apis.simIspChangeCountry, reqData).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success'),
        });
        this.$emit('success');
        this.close();
      });
    },
    onCancel() {
      this.close();
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss"></style>
